import angular from 'angular'
import { PayStubComponent } from './pay-stub.component';
import { PayStubContainerComponent } from './pay-stub-container.component';
import { PayStubEntryComponent } from './pay-stub-entry.component';
import { PayStubCommissionsComponent } from './pay-stub-commissions.component';
import { PayStubModalComponent } from './pay-stub-modal.component';
import { PayStubTotalsSummaryComponent } from './pay-stub-totals-summary.component';
import { PayStubRoutingModule } from './pay-stub-routing.module';
import { PayStubTaxDeductionComponent } from './pay-stub-tax-deduction.component';
import { EditPayStubComponent } from './edit/edit-pay-stub.component'
import { EditPayStubEntryComponent } from './edit/edit-pay-stub-entry.component'
import { EditPayStubCommissionsComponent } from './edit/edit-pay-stub-commissions.component'

/** A module that defines components used to display an employee's pay stub. */
export const PayStubModule = angular
    .module("apex.mainApp.payroll.payStub", [
        PayStubRoutingModule
    ])
    .component("apexPayStubContainer", PayStubContainerComponent)
    .component("apexPayStubModal", PayStubModalComponent)
    .component("apexPayStub", PayStubComponent)
    .component("apexPayStubEntry", PayStubEntryComponent)
    .component("apexPayStubCommissions", PayStubCommissionsComponent)
    .component("apexPayStubTotalsSummary", PayStubTotalsSummaryComponent)
    .component("apexPayStubTaxDeduction", PayStubTaxDeductionComponent)
    .component("apexEditPayStub", EditPayStubComponent)
    .component("apexEditPayStubEntry", EditPayStubEntryComponent)
    .component("apexEditPayStubCommissions", EditPayStubCommissionsComponent)
    .name;
